import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { widgetItemStyle, widgetItemCountStyle, widgetItemTitleStyle } from 'basics/styles/widget.style';
import { CountWidgetPropsType } from 'components/CountWidgets/CountWidget.types';
import useTargetsReachWidget from 'components/CountWidgets/TargetsReachWidget/TargetsReachWidget.hook';
import Loader from 'yoda-ui/components/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const TargetsReachWidget: FC<CountWidgetPropsType> = ({
  filters,
  useAdminFilters,
}) => {
  const { value, loading } = useTargetsReachWidget(filters, useAdminFilters);
  const { t } = useTranslation();

  return (
    <Box sx={ widgetItemStyle } >
      <Box sx={ widgetItemTitleStyle }>
        <img src='/dashboard/reach-icon.svg' alt="Reach-icon" style={ { height: 'inherit' } } />
        { t('maya_targets_reach_widget_label') }
      </Box>
      <Box sx={ widgetItemCountStyle } visibility={ loading ? 'hidden' : 'inherit' }>
        { value !== undefined ? value : '-' }
      </Box>
      { loading ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : null }
    </Box>
  );
};

export default TargetsReachWidget;
